<template>
  <div class="finished">
    <h2>
      {{ title }}
    </h2>
    <div class="plate">
    <span v-for="(model, index) in models" v-bind:key="model.id">
      <Model :id="index" :background="model.background" :searched="model.searched" :rotationSpeed="0" :transformation="model.rotation" /> <!--@modelAccepted="$emit('modelAccepted');"-->
    </span>
    </div>
    <p>{{ message }}</p>
    <Button :text="buttons.replay" type="start" @gamestate="update" />
    <div class="button" v-if="showActionLink" ><a class="btn" :href="actionLink"  :target="actionTarget">{{ buttons.next }}</a></div>
  </div>
</template>

<script>

const Button = () => import('./Buttons.vue')
// import Button from './Buttons.vue'
// import Model from './Model.vue'
const Model = () => import('./Model.vue')

export default {
  name: 'FinalScreen',
  components: {
    Button,
    Model
  },
  props: {
    ModelsFound: Array,
    searchedRounds: Number
  },
  data: function(){
    return{
      models: this.ModelsFound,
      title: null,
      message: null,
      buttons:{
        next: window.options.action.text,
        replay: window.config.text.outro.button_replay
      },
      showActionLink: window.showAction

    }
  },
  computed:{
    actionLink() {
            if (window.options.action.type == 'next' && window.nextStepUrl) {
                return window.nextStepUrl;
            }
            else if (window.options.action.type == 'external' && window.options.action.href) {
                return window.options.action.href;
            }
            else {
              return null;
            }
        },
    actionTarget() {
            if (window.options.action.type == 'external' && window.options.action.href) {
                return "_blank";
            }
            return '_self';
        }
  },
  created: function(){
    this.setRandomRotation();
    this.switchFeedback();

  },
  methods: {
    update(){
      this.$emit('gamestate', 'restart');
    },
    setRandomRotation(){
      this.models.forEach(model => {
        model.rotation = 'rotate('+Math.floor(Math.random() * 360)+'deg)';
        // document.getElementById(key).style.transform = ;
      });
      // transform: rotate(360deg);
    },
    switchFeedback(){
      var indicator = this.searchedRounds - this.ModelsFound.length;
      switch (indicator) {
        case this.searchedRounds:
            this.title = window.config.text.outro.messages[2].headline;
            this.message = window.config.text.outro.messages[2].text;
          break;
        case 0:
        this.title = window.config.text.outro.messages[0].headline;
        this.message = window.config.text.outro.messages[0].text;
          break;
        default:
        this.title = window.config.text.outro.messages[1].headline;
        this.message = window.config.text.outro.messages[1].text;
          break;
      }
    }
  }
}
</script>
